export const returnNumberValues = (text,field) => {
    text = text.replace(/\D/g, "");
    if (field === "phone") {
      if (text.startsWith("0")) {
        text = text.slice(1);
      }
    }
    return text
  };